import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";

export class CompetitorPlayerStatsModuleShotMapShowMoreClickEventModel extends BaseAnalyticsEvent {
  athleteId: Number;
  gameId: Number;
  status: Number;
  outcome: Number;
  clickType: String;

  constructor(params) {
    super('show-more-click', 'shot-map-popup', 'live-stats');

    this.athleteId = params.athleteId;
    this.gameId = params.gameId;
    this.status = params.status;
    this.outcome = params.outcome;
    this.clickType = params.clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.athleteId = this.athleteId;
    properties.gameId = this.gameId;
    properties.status = this.status;
    properties.outcome = this.outcome;
    properties.clickType = this.clickType;

    return properties;
  }
}
